import React, { Component } from "react";
import { edit, trash, more } from "Icons/index";
import t from "Utils/translation";
import DropdownMenu from "Components/dropdownMenu/DropdownMenu";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";

import s from "./mainCustomizationRow.scss";

export default class MainCustomizationRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ddOpened: false,
    };
  }

  setDropdownMenuOpen = (newVal) => {
    this.setState({ ddOpened: newVal });
  };

  render() {
    const {
      mainCustomization,
      showMainCustomization,
      showDeleteConfirmModal,
      showManager,
      showActions = true,
      canEdit = true,
    } = this.props;

    let image;
    if (mainCustomization.logo) {
      image = (
        <div className={s.logo}>
          <img src={`${BASE_URL_PUBLIC_ASSETS}${mainCustomization.logo}`} alt="logo" title="logo" />
        </div>
      );
    } else {
      image = (
        <div className={s.logo}>
          <img src={`${BASE_URL_PUBLIC_ASSETS}/logo_panel.svg`} alt="logo" title="logo" />
        </div>
      );
    }

    return (
      <tr key={mainCustomization.id}>
        <td data-label={t("table.header.logo")}>{image}</td>
        {showManager && (
          <td data-label={t("table.header.managers")} className="textOverflow">
            {mainCustomization.manager_fullname} [{mainCustomization.manager_code}]
          </td>
        )}
        <td data-label={t("table.header.company")} className="textOverflow">
          {mainCustomization.company}
        </td>
        <td data-label={t("table.header.supportURL")} className="hideOnMobile">
          {mainCustomization.help_desk_url}
        </td>
        {showActions && (
          <td>
            <DropdownMenu
              isOpen={this.state.ddOpened}
              onOpenChange={this.setDropdownMenuOpen}
              actions={[
                {
                  isHidden: !canEdit,
                  onClick: showMainCustomization,
                  icon: edit,
                  label: t("button.edit"),
                },
                {
                  onClick: () => showDeleteConfirmModal(mainCustomization),
                  icon: trash,
                  label: t("ddMenu.delete"),
                },
              ]}
            >
              <ButtonIcon icon={more} />
            </DropdownMenu>
          </td>
        )}
      </tr>
    );
  }
}
